(ns frontend.ux-overhaul.listing.screening.model)

(def root-path [::state])

(def bulk-edit-open?-key :bulk-edit-open?)
(def bulk-edit-open?-full-path (conj root-path bulk-edit-open?-key))
